import { Link } from "react-router-dom";
import React, { useState, useContext } from "react";
import CartContext from "../../../context/CartContext";
// import {useStateContext} from '../Provider.js'

const Header = (props) => {
  const { cartItems, showHideCart } = useContext(CartContext);
  const [isMobile, setisMobile] = useState(false);

  // const showSidebar = () => setSidebar(!sidebar);
  // const globalState = useStateContext();
  return (
    <header>
      <div className="logo">
        <a href="/">SNEAKSHOP</a>
      </div>

      <div
        className={isMobile ? "menu-mobile" : "menu"}
        onClick={() => setisMobile(false)}
      >
        <a href="#">About</a>
        {/* <a href="/products/new-arrivals">New Arrival</a> */}
        <a href="/products">Products</a>
        <Link to="#">Login</Link>
        <Link id="CartBtnRoot" className="cart-link" onClick={showHideCart}>
          Cart
          <div>{cartItems.length ? <span> {cartItems.length} </span> : ""}</div>
        </Link>
      </div>
      <button
        className="mobile-toggle-icon"
        onClick={() => setisMobile(!isMobile)}
      >
        {isMobile ? <i className="ti-close"></i> : <i className="ti-menu"></i>}
      </button>
    </header>
  );
};

export default Header;
